import { render, staticRenderFns } from "./Platillos.vue?vue&type=template&id=401c61a6&"
import script from "./Platillos.vue?vue&type=script&lang=js&"
export * from "./Platillos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports